export default "__VITE_ASSET__22a8_gQG__"